import {useState} from "react";

const DeleteIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_17_310)">
            <path
                d="M7.52836 5.83398H8.46954V12.4222H7.52836V5.83398ZM10.3519 5.83398H11.2931V12.4222H10.3519V5.83398ZM4.70483 5.83398H5.64601V12.4222H4.70483V5.83398Z"
                fill="white"/>
            <path
                d="M15.5288 3.9533H14.117V3.01212C14.117 2.44741 13.7406 2.07094 13.1759 2.07094H10.3523V1.60036C10.3523 1.03565 9.97585 0.65918 9.41115 0.65918H6.58762C6.02291 0.65918 5.64644 1.03565 5.64644 1.60036V2.07094H2.82291C2.25821 2.07094 1.88174 2.44741 1.88174 3.01212V3.9533H0.469971V4.89447H2.35232V13.3651C2.35232 14.4004 3.19938 15.2474 4.23468 15.2474H11.7641C12.7994 15.2474 13.6464 14.4004 13.6464 13.3651V4.89447H15.5288V3.9533ZM6.58762 1.69447H9.41115V2.16506H6.58762V1.69447ZM2.82291 3.01212H13.1759V3.9533H2.82291V3.01212ZM12.7053 13.3651C12.7053 13.8356 12.3288 14.3062 11.7641 14.3062H4.23468C3.76409 14.3062 3.2935 13.9298 3.2935 13.3651V4.89447H12.7053V13.3651Z"
                fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_17_310">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

const FeaturedIconDefault = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.4532 1.02148H3.57822C2.51572 1.02148 1.65479 1.88242 1.65479 2.94492V14.0355C1.65479 14.8027 2.50947 15.2605 3.14854 14.8355L8.01572 11.5949L12.8813 14.8355C13.5204 15.2605 14.3751 14.8027 14.3751 14.0355V2.94492C14.3751 1.88242 13.5142 1.02148 12.4532 1.02148ZM11.8235 6.07305C11.8235 6.59023 11.4032 7.01055 10.886 7.01055H5.14541C4.62822 7.01055 4.20791 6.59023 4.20791 6.07305C4.20791 5.55586 4.62822 5.13555 5.14541 5.13555H10.8845C11.4032 5.13555 11.8235 5.55586 11.8235 6.07305Z"
            fill="white"/>
    </svg>
);

const FeaturedIconSelected = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_18_334)">
            <path
                d="M3.42542 15.2519L3.42564 15.2517L8.01568 12.1956L12.6042 15.2517L12.6045 15.2519C13.5756 15.8977 14.8751 15.2022 14.8751 14.0355V2.94492C14.8751 1.60654 13.7906 0.521484 12.4532 0.521484H3.57822C2.23958 0.521484 1.15479 1.60628 1.15479 2.94492V14.0355C1.15479 15.2022 2.45433 15.8977 3.42542 15.2519ZM11.3235 6.07305C11.3235 6.31409 11.1271 6.51055 10.886 6.51055H5.14541C4.90436 6.51055 4.70791 6.31409 4.70791 6.07305C4.70791 5.832 4.90436 5.63555 5.14541 5.63555H10.8845C11.1276 5.63555 11.3235 5.83254 11.3235 6.07305Z"
                fill="#9747FF" stroke="white"/>
        </g>
        <defs>
            <clipPath id="clip0_18_334">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

const FeaturedIndicator = () => (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.05482 22.7539L4.05508 22.7537L11.0233 18.1142L17.9892 22.7537L17.9895 22.7539C19.3465 23.6564 21.1624 22.6844 21.1624 21.0543V4.41836C21.1624 2.49356 19.6027 0.933203 17.6796 0.933203H4.36709C2.44197 0.933203 0.881934 2.49324 0.881934 4.41836V21.0543C0.881934 22.6844 2.69779 23.6564 4.05482 22.7539ZM16.1351 9.11055C16.1351 9.55496 15.7732 9.9168 15.3288 9.9168H6.71787C6.27346 9.9168 5.91162 9.55496 5.91162 9.11055C5.91162 8.66614 6.27346 8.3043 6.71787 8.3043H15.3265C15.7739 8.3043 16.1351 8.66679 16.1351 9.11055Z"
            fill="#9747FF" stroke="white" stroke-width="1.2"/>
    </svg>
);

const ImageCard = ({src, onDelete, onFeature, isFeatured, defaultPrompt, onUpdatePrompt}) => {
    const [hovered, setHovered] = useState(false);
    const [prompt, setPrompt] = useState(defaultPrompt || '');

    const handlePromptChange = (e) => {
        setPrompt(e.target.value);
        onUpdatePrompt(e.target.value);
    };

    return (
        <div
            className="w-60 h-60 relative rounded overflow-hidden mr-2"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <img src={src} alt="Uploaded asset" className="w-full h-full object-cover"/>
            {hovered && (
                <>
                    <div className="absolute inset-0 bg-black bg-opacity-40"/>
                    <input
                        type="text"
                        className="absolute bottom-3 left-3 w-11/12 bg-white bg-opacity-20 rounded-3xl border backdrop-blur-sm p-1.5 text-sm text-white placeholder-white"
                        placeholder="Description..."
                        value={prompt}
                        onChange={handlePromptChange}
                        style={{
                            paddingLeft: '0.8rem',
                            paddingRight: '0.8rem',
                        }}
                    />
                    <button
                        className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 rounded-full shadow backdrop-blur-sm hover:bg-opacity-40 transition-opacity duration-150"
                        onClick={onFeature}
                    >
                        {!isFeatured ? <FeaturedIconDefault/> : <FeaturedIconSelected/>}
                    </button>
                    <button
                        className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 rounded-full shadow backdrop-blur-sm hover:bg-opacity-40 transition-opacity duration-150"
                        onClick={onDelete}
                    >
                        <DeleteIcon/>
                    </button>
                </>
            )}
            {!hovered && (
                <>
                    {prompt && (
                        <div
                            className="absolute bottom-3 left-3 w-11/12 bg-gray-500/30 rounded-3xl border backdrop-blur-sm p-1.5 text-sm text-white">
                        {prompt}
                        </div>
                    )}
                    {isFeatured && (
                        <div className="absolute top-3 left-3">
                            <FeaturedIndicator/>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ImageCard